import { atom } from 'jotai';
import SpineLoader from '../loader/SpineLoader';

import filesList from '../assets.json'
import { loadable } from 'jotai/utils';
import { useQuery } from 'react-query';

type Cache = {[key: string]: any}

const loader = new SpineLoader('/assets')
const files = filesList


const getCache = async () => {
  const res = await Promise.all(files.map(f => new Promise<any>((res, rej) => loader.load(f, res, undefined, rej)) ))

  return res.reduce((acc, val, i) => {
    acc[files[i]] = res[i]
    return acc
  }, {} as Cache) as Cache

}

// read-only (after initial suspended load)
export const assetAtom = atom(getCache)


export const loadableAssets = loadable(assetAtom)
